// extracted by mini-css-extract-plugin
export var scrollArea = "_nr-0";